import { ReadonlyURLSearchParams } from 'next/navigation';

export const getQueryParams =
    (searchParams: ReadonlyURLSearchParams) =>
    <K extends string>(...params: K[]): Record<K, string | undefined> => {
        const urlSearchParams = new URLSearchParams(searchParams ?? {});

        return params.reduce<Record<K, string | undefined>>(
            (acc, param) => ({
                ...acc,
                [param]: urlSearchParams.get(param) ?? undefined,
            }),
            {} as Record<K, string | undefined>,
        );
    };

export const addQueryParamsToUrl = (url: string) => (paramsWithVals: string) =>
    paramsWithVals ? `${url}?${paramsWithVals}` : '';

export const createQueryParamString = (queryParams: Record<string, string | undefined>) =>
    Object.entries(queryParams).reduce((acc: string, [key, val], idx) => {
        if (idx === 0) {
            return val ? `${acc}${key}=${val}` : acc;
        } else {
            return val ? `${acc}&${key}=${val}` : acc;
        }
    }, '?');

export const createQueryString = (
    queries: { name: string; value: string | number } | { name: string; value: string | number }[],
    searchParams: ReadonlyURLSearchParams,
) => {
    const params = new URLSearchParams(searchParams ?? {});
    if (Array.isArray(queries)) {
        queries.forEach((q) => {
            params.set(q.name, q.value.toString());
        });
    } else {
        params.set(queries.name, queries.value.toString());
    }

    return params.toString();
};
